import React, { useState } from 'react';
import axios from 'axios';

const BLUE = '#00388A';

const questions = [
  { id: 1, text: "I found it hard to wind down" },
  { id: 2, text: "I was aware of dryness of my mouth" },
  { id: 3, text: "I couldn't seem to experience any positive feeling at all" },
  { id: 4, text: "I experienced breathing difficulty (e.g. excessively rapid breathing, breathlessness in the absence of physical exertion)" },
  { id: 5, text: "I found it difficult to work up the initiative to do things" },
  { id: 6, text: "I tended to over-react to situations" },
  { id: 7, text: "I experienced trembling (e.g. in the hands)" },
  { id: 8, text: "I felt that I was using a lot of nervous energy" },
  { id: 9, text: "I was worried about situations in which I might panic and make a fool of myself" },
  { id: 10, text: "I felt that I had nothing to look forward to" },
  { id: 11, text: "I found myself getting agitated" },
  { id: 12, text: "I found it difficult to relax" },
  { id: 13, text: "I felt down-hearted and blue" },
  { id: 14, text: "I was intolerant of anything that kept me from getting on with what I was doing" },
  { id: 15, text: "I felt I was close to panic" },
  { id: 16, text: "I was unable to become enthusiastic about anything" },
  { id: 17, text: "I felt I wasn't worth much as a person" },
  { id: 18, text: "I felt that I was rather touchy" },
  { id: 19, text: "I was aware of the action of my heart in the absence of physical exertion (e.g. sense of heart rate increase, heart missing a beat)" },
  { id: 20, text: "I felt scared without any good reason" },
  { id: 21, text: "I felt that life was meaningless" }
];

const options = [
  { val: 0, label: "0" },
  { val: 1, label: "1" },
  { val: 2, label: "2" },
  { val: 3, label: "3" }
];

const legend = [
  "0 Did not apply to me at all",
  "1 Applied to me to some degree, or some of the time",
  "2 Applied to me to a considerable degree or a good part of time",
  "3 Applied to me very much or most of the time"
];

const DASS21Form = ({ userHash, onComplete }) => {
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSelect = (qIdx, value) => {
    setAnswers({ ...answers, [qIdx]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const responses = [];
    for (let i = 0; i < 21; i++) {
      responses.push(answers[i] !== undefined ? answers[i] : 0);
    }
    const payload = {
      student_id: userHash || "STUDENT_TEST_001",
      responses: responses
    };

    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
      const res = await axios.post(`${baseUrl}/api/assessment/dass21`, payload);
      onComplete(res.data);
    } catch (err) {
      console.error("Submission Error:", err.response?.data);
      alert("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={formCardStyle}>
      <header style={{ marginBottom: '30px', textAlign: 'center' }}>
        <p style={stepLabelStyle}>Questionnaire 1/3</p>
        <p style={introTextStyle}>Think about your level of stress in the last month. Please answer the following questions using the following scale:</p>
        <div style={legendBoxStyle}>
          {legend.map((item, i) => (
            <p key={i} style={legendTextStyle}>{item}</p>
          ))}
        </div>
      </header>

      <div style={questionsWrapperStyle}>
        {questions.map((q, index) => (
          <div key={q.id} style={questionRowStyle}>
            <p style={questionTextStyle}>
              <span style={numberStyle}>{index + 1}.</span> {q.text}
            </p>

            <div style={optionsContainerStyle}>
              {options.map((opt) => (
                <button
                  key={opt.val}
                  onClick={() => handleSelect(index, opt.val)}
                  style={{
                    ...optionButtonStyle,
                    backgroundColor: answers[index] === opt.val ? BLUE : 'transparent',
                    color: answers[index] === opt.val ? 'white' : '#555',
                    borderColor: answers[index] === opt.val ? BLUE : '#DDD',
                  }}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            ...submitButtonStyle,
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? "Processing..." : "Continue"}
        </button>
      </div>
    </div>
  );
};

const stepLabelStyle = { fontSize: '13px', color: BLUE, fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '15px' };
const formCardStyle = { maxWidth: '700px', width: '100%', backgroundColor: '#FFFFFF', padding: '50px 40px', borderRadius: '20px', boxShadow: '0 2px 15px rgba(0,0,0,0.03)' };
const introTextStyle = { fontSize: '18px', lineHeight: '1.6', color: '#444', marginBottom: '20px', textAlign: 'center' };
const legendBoxStyle = { textAlign: 'left', padding: '15px 20px', backgroundColor: 'rgba(0, 0, 0, 0.03)', borderRadius: '12px', marginBottom: '40px' };
const legendTextStyle = { fontSize: '13px', margin: '4px 0', color: '#666', lineHeight: '1.4' };
const questionsWrapperStyle = { display: 'flex', flexDirection: 'column', gap: '15px' };
const questionRowStyle = { textAlign: 'left', borderBottom: '1px solid #F5F5F5', paddingBottom: '15px', display: 'flex', flexDirection: 'column' };
const questionTextStyle = { fontSize: '15.5px', color: '#333', marginBottom: '12px', lineHeight: '1.5' };
const numberStyle = { color: BLUE, fontWeight: '600', marginRight: '8px' };
const optionsContainerStyle = { display: 'flex', gap: '10px' };
const optionButtonStyle = { width: '38px', height: '38px', borderRadius: '50%', border: '1px solid', fontSize: '14px', cursor: 'pointer', transition: 'all 0.2s ease', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '500' };
const submitButtonStyle = { backgroundColor: BLUE, color: 'white', padding: '15px 50px', border: 'none', borderRadius: '50px', fontSize: '16px', fontWeight: '600', letterSpacing: '0.5px', transition: 'all 0.3s ease' };

export default DASS21Form;